// Must stay first — strips hub tokens from the URL before analytics loads.
import './captureUrlSecrets.js'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// Self-hosted fonts: Inter carries body/UI, Fraunces carries headings.
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/fraunces/400.css'
import '@fontsource/fraunces/500.css'
import '@fontsource/fraunces/600.css'
import '@fontsource/fraunces/700.css'
import './index.css'
import App from './App.jsx'
import { Capacitor } from '@capacitor/core'
import { startAnalytics } from './services/analytics'

// Arms GA4 but loads nothing until the user opts in on Data & Privacy.
startAnalytics()

// After a deploy, a page loaded from the previous release can request a lazy
// chunk whose hashed filename no longer exists; the SPA rewrite answers with
// HTML and the import dies (blank page). Vite signals this exact failure —
// reload once to pick up the new release. The timestamp guard prevents loops.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'pp-preload-reload-at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 30000) return; // reload didn't help — surface the error
  event.preventDefault();
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// On iOS the splash otherwise sits out its full launchShowDuration (1.5s in
// capacitor.config.json) even when the app is ready long before that. Hide it
// once React has painted. launchAutoHide stays true, so the timeout remains the
// backstop if this never runs.
if (Capacitor.isNativePlatform()) {
  requestAnimationFrame(() => {
    import('@capacitor/splash-screen')
      .then(({ SplashScreen }) => SplashScreen.hide())
      .catch(() => {});
  });
}
